import { useIsPlatformJourney } from '@client/components/mylounge/platform-journeys';
import useCustomCommercialMessage from '../use-commercial-message';

interface CommercialMessageVisibility {
    showCommercialMessageModal: boolean;
}

export const useCommercialMessageVisibility = (): CommercialMessageVisibility => {
    const commercialMessage = useCustomCommercialMessage();
    const isPlatformJourneyEnabled = useIsPlatformJourney();

    const showCommercialMessageModal =
        !isPlatformJourneyEnabled &&
        commercialMessage.isEnabled &&
        commercialMessage.isModal &&
        commercialMessage.isShown;

    return {
        showCommercialMessageModal,
    };
};
